export default "__VITE_ASSET__CeOXBLaX__"